import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import AddTransaction from '../Routes/AddTransaction.js'
import AccountDetails from "./AccountDetails.js";
import ViewTransactionHistory from '../Components/ViewTransactionHistory.js'
import { useNavigate } from "react-router-dom";
import RegistrationInfo from "./RegistrationInfo.js";
import { useState, useEffect } from "react";
import '../Styles/AccountCard.scss';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import RegistrationDetails from "./RegistrationDetails.js";

function AccountCard({ queriedAccount }) {

   console.log("Queried Registration", queriedAccount)
   const navigate = useNavigate()
   const [AddPaymentVisibility, setAddPaymentVisibility] = useState(false)
   const [viewTransactionsVisibility, setViewTransactionsVisibility] = useState(false)
   const [viewRegistrationVisibility, setViewRegistrationVisibility] = useState(false)
   const [viewAccountDetailsVisibility, setViewAccountDetailsVisibility] = useState(false)
   const [currentAmountDue, setCurrentAmountDue] = useState()

   return (
      <div className="AccountCardContainer">
         <div className="AccountCardContent">
            <div className="AccountCardName">
               Name: {queriedAccount.first_name + " " + queriedAccount.last_name}
            </div>
            <div className="AccountCardEmail">
               Email: {queriedAccount.email_address}
            </div>
            <button onClick={() => navigate('/admindaycampregistration', { state: queriedAccount })}>
               Register
            </button>
            <div>

            </div>
         </div>

      </div>
   )
}
export default AccountCard